// @flow

import type { Node } from 'react';

type TProps = {
  setPopupContent: (N: Node) => void
};

export const Header = 'Metal Weight';

export function Content({ setPopupContent }: TProps) {
  return (
    <div>
      <p>
        The total weight (in grams) of all precious metal contained in the
        setting.
      </p>
    </div>
  );
}
